import React, { PropsWithChildren } from "react";
import styles from "./drawer-button-wrapper.module.scss";

const cssClassName = "drawer-button-wrapper";

export const DrawerButtonWrapper = ({ children }: PropsWithChildren) => {
  return <div className={styles[cssClassName]}>{children}</div>;
};
